import { useApi } from './api'

export const apiAtividadeConsolidada = () => {
   const { api } = useApi()
   const obter = async (params) => {
      const { data } = await api.get(`/atividade/consolidada`, { params })
      return data
   }

   const obterDetalhes = async (params) => {
      const { data } = await api.get(`/atividade`, { params })
      return data
   }

   const registrar = async (payload) => {
      const { data } = await api.post(`/atividade`, payload)
      return data
   }

   const obterPorId = async (id) => {
      const { data } = await api.get(`/atividade/${id}`)
      return data
   }

   const editar = async (payload) => {
      const { data } = await api.put(`/atividade/${payload.id}`, payload.body)
      return data
   }

   const desconsiderar = async (payload) => {
      const { data } = await api.put(`/atividade/${payload.id}/desconsiderar`, { observacoes: payload.observacao })
      return data
   }

   return {
      obter,
      obterDetalhes,
      registrar,
      editar,
      desconsiderar,
      obterPorId
   }
}
